import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import { CounterpartyConnectionTableRow } from './CounterpartyConnectionTableRow';
import {
  getCounterpartyConnectionRowKey,
  type CounterpartyConnectionItem,
  type ConnectionsSegmentMode,
} from './CounterpartyConnections.helpers';

import styles from './CounterpartyConnections.module.sass';

type HeadCellClass = 'headName' | 'headType' | 'headUsd' | 'headHops';

const TABLE_HEAD_COLUMNS: readonly {
  translationKey: string;
  cellClass: HeadCellClass;
}[] = [
  {
    translationKey: 'translation.connections_table_entity',
    cellClass: 'headName',
  },
  { translationKey: 'translation.entity_type', cellClass: 'headType' },
  {
    translationKey: 'translation.connections_col_received_usd',
    cellClass: 'headUsd',
  },
  {
    translationKey: 'translation.connections_table_hops',
    cellClass: 'headHops',
  },
  {
    translationKey: 'translation.connections_col_sent_usd',
    cellClass: 'headUsd',
  },
  {
    translationKey: 'translation.connections_table_hops',
    cellClass: 'headHops',
  },
];

const HEAD_STYLES: Record<HeadCellClass, string> = {
  headName: styles.headName,
  headType: styles.headType,
  headUsd: styles.headUsd,
  headHops: styles.headHops,
};

export type CounterpartyConnectionsTableProps = {
  rows: CounterpartyConnectionItem[];
  connectionAmountDivisor?: number;
  segment: ConnectionsSegmentMode;
};

export function CounterpartyConnectionsTable({
  rows,
  connectionAmountDivisor,
  segment,
}: CounterpartyConnectionsTableProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.table}>
      <div className={styles.tableViewport}>
        <div className={cx(styles.headRow, styles.gridRow)}>
          {TABLE_HEAD_COLUMNS.map((column, index) => (
            <div
              key={`${column.translationKey}-${index}`}
              className={HEAD_STYLES[column.cellClass]}
            >
              {t(column.translationKey)}
            </div>
          ))}
        </div>

        <div className={styles.list}>
          {rows.length === 0 ? (
            <div className={styles.filterEmpty}>
              {t('translation.connections_filter_empty') || ''}
            </div>
          ) : (
            rows.map((connection, index) => (
              <CounterpartyConnectionTableRow
                key={getCounterpartyConnectionRowKey(connection, index)}
                connection={connection}
                connectionAmountDivisor={connectionAmountDivisor}
                segment={segment}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}
